import { FreeTierUsageSummary } from '../services/api';

interface FreeTierErrorDetail {
  code: string;
  feature?: string;
  message?: string;
  usage?: FreeTierUsageSummary;
}

const FREE_TIER_LIMIT_CODE = 'FREE_TIER_LIMIT_REACHED';

export const isFreeTierLimitError = (error: any): boolean => {
  const status = error?.response?.status;
  const detail: FreeTierErrorDetail | undefined = error?.response?.data?.detail;
  return status === 402 && detail?.code === FREE_TIER_LIMIT_CODE;
};

export const extractFreeTierUsage = (error: any): FreeTierUsageSummary | null => {
  const detail: FreeTierErrorDetail | undefined = error?.response?.data?.detail;
  return detail?.usage ?? null;
};

export const extractFreeTierFeature = (error: any): string | null => {
  const detail: FreeTierErrorDetail | undefined = error?.response?.data?.detail;
  return detail?.feature ?? null;
};

export const extractFreeTierMessage = (error: any): string | null => {
  const detail: FreeTierErrorDetail | undefined = error?.response?.data?.detail;
  return detail?.message ?? null;
};
